module.exports = __webpack_public_path__ + "media/images/landing_page/majaslapa-sakumlapa-98f43a203a5708f414f7222e2ea3edd2.png";